const reducer = (state, action)=>
{
    if(action.type === 'CLEAR_CART')
    {
        return {...state, cart : [] };
    }
    else if(action.type === 'LOADING')
    {
        return {...state, loading : true };
    }
    else if(action.type === 'DISPLAY_ITEMS')
    {
        const data = action.payload;
        return {...state, loading : false, cart : data };
    }
    else if(action.type === 'REMOVE')
    {
        const cartID = action.payload;
        const { cart } = state;
        const newCart  = cart.filter((items)=>
        {
            return items.id !== cartID;
        });

        return {...state, cart : newCart };
    }
    else if(action.type === 'INCREASE')
    {
        const itemID = action.payload;
        const { cart } = state;
        let tempCart = cart.map((item)=>
        {
            if(item.id === itemID)
            {
                return {...item, amount : item.amount + 1 };
            }
            return item;
        })

        return {...state, cart : tempCart };
    }
    else if(action.type === 'DECREASE')
    {
        const itemID = action.payload;
        const { cart } = state;
        let tempCart = cart.map((item)=>
        {
            if(item.id === itemID)
            {
                return {...item, amount : item.amount - 1 };
            }
            return item;
        })

        tempCart = tempCart.filter((items)=>
        {
            return items.amount !== 0 ;    
        })

        return {...state, cart : tempCart };
    }
    else if(action.type === 'GET_TOTALS')
    {
        let { totalPrice, amount } = state.cart.reduce((values, item)=>
        {
            const { price, amount } = item;
            const itemTotalPrice = price * amount;
            values.totalPrice += itemTotalPrice;
            values.amount += amount;
            return values;
        }, 
        {
            totalPrice : 0,
            amount : 0
        });

        totalPrice = parseFloat(totalPrice.toFixed(2));
        return {...state, total : totalPrice, amount };
    }
    return state;
}

export default reducer;